import { useState, useEffect } from "react";
import { listenToCustomers } from "../services/customerService";

export function useCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);

  useEffect(() => {
    const unsubscribe = listenToCustomers((liveCustomers) => {
      setCustomers(liveCustomers);
      setLoading(false);
      setError(null);
    });
    return () => unsubscribe();
  }, []);

  const activeCustomers = customers.filter(c => c.status === "Active");
  const vipCustomers    = customers.filter(c => c.status === "VIP");
  const totalSpent      = customers.reduce((sum, c) => sum + (c.spent || 0), 0);

  return {
    customers,
    loading,
    error,
    activeCustomers,
    vipCustomers,
    totalSpent,
    totalCount: customers.length,
  };
}